/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tidy_New_Deer_ComposeInputs */

const fr_tidy_new_deer_compose = /** @type {(inputs: Tidy_New_Deer_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affilié`)
};

/**

* @param {Tidy_New_Deer_ComposeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tidy_new_deer_compose = /** @type {((inputs?: Tidy_New_Deer_ComposeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tidy_New_Deer_ComposeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tidy_new_deer_compose(inputs)
});